import React from "react";
import { connect } from "react-redux";
import { getPlanByRequirements, isStackSupportedByUser } from "../../helpers/data/_handlers/plans";
import styles from "./StackPaymentMessage.module.scss";
import Link from "next/link";
import { NAV_PRICING } from "../../settings/navigation";

function StackPaymentMessage({stack, user, plans}) {

    const requiredPlanData = getPlanByRequirements(stack.plan, plans);
    const isSupportedByPlan = isStackSupportedByUser(stack.plan);
    const redirectURL = `${NAV_PRICING}?stack_id=${stack._id}`;

    if (
        !!Object.keys(user || {}).length
        && (!requiredPlanData.isFree && !isSupportedByPlan || user?.deployments_left === 0)
    ) {
        return (
            <div className={styles['message']}>
                <div className={styles['message__icon']}>
                    <i className='fas fa-exclamation-triangle' aria-hidden="true"/>
                </div>
                <div className={styles['message__content']}>
                    {/*{*/}
                    {/*    !requiredPlanData.isFree && !isSupportedByPlan &&*/}
                    {/*    <p className={styles['message__content__item']}>*/}
                    {/*        <span>{stack.name}</span> requires at*/}
                    {/*        least <span>{requiredPlanData.name}</span> subscription.*/}
                    {/*    </p>*/}
                    {/*}*/}
                    {
                        user?.deployments_left === 0 &&
                        <p className={styles['message__content__item']}>You have reached deployments limit.</p>
                    }
                    <p className={styles['message__content__item']}>
                        After selecting a cloud option, you have the choice
                        to either <Link href={redirectURL}>upgrade your plan</Link> or
                        make a <strong>one-time purchase</strong> for a single deployment
                    </p>
                </div>
            </div>
        );
    } else return null
}

const mapStateToProps = store => ({
    user: store.userData.user,
});

export default connect(mapStateToProps)(StackPaymentMessage)